module.exports = __webpack_public_path__ + "05_medium_grey.e6230f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/05_medium_grey.png
// module id = zZXW
// module chunks = 0